import React, { useState } from 'react';
import RestUtilities from '../services/Base';

const CallToken = () => {
  const [csrf, setCsrf] = useState('');

  if (!csrf) {
    RestUtilities.get("/antiforgery/token").then(() => {
        const cookie = document.cookie;

        if(cookie)
        {
            const xsrfToken = cookie?.split("; ")?.find(row => row.startsWith("XSRF-TOKEN="))?.split("=")[1] ?? "error";

            setCsrf(xsrfToken);
        }
    });

  }

  return <input type="hidden" value={csrf} name="RequestVerificationToken" />;
};

export default CallToken;
